/**
 * @param lang - User-facing language code (e.g., 'en', 'zh', 'es')
 * @returns Tolgee-compatible language code
 */
export const getTogloeeLanguageCode = (lang: string): string => {
  const languageMap: Record<string, string> = {
    // Existing
    zh: "zh-Hans",
    en: "en",
    // New additions
    es: "es", // Spanish
    fr: "fr", // French
    de: "de", // German
  };

  return languageMap[lang] || "en";
};

export default getTogloeeLanguageCode;
